export default __webpack_public_path__ + "static/media/_DSC0798.75fa9358.JPG";